import { queryParamsReducer } from './queryParams';
import { aggregationsReducer } from './aggregations';
import { resultsReducer } from './results';
import { layoutReducer } from './layout';
import { searchMenuReducer } from './searchMenu';
import { watcherExistsReducer } from './watcherExists';

export const reducersRaw = {
  queryParams: queryParamsReducer,
  aggregations: aggregationsReducer,
  results: resultsReducer,
  layout: layoutReducer,
  searchMenu: searchMenuReducer,
  watcherExists: watcherExistsReducer,
};
